import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import CardStripe from "@components/CardStripe/CardStripe";
import { rootStore } from "@store/Route";
import { delay } from "@utils/helper";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { PaymentMethodType } from "@store/Payment";
import AddCreditCard from "@view/payments/components/AddCreditCard";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "@constants/api";

const ManageCreditCards = observer(() => {
  const { landing, payment } = rootStore;
  const { token } = landing;
  const {
    getListPaymentMethods,
    fetchingPaymnetMethods,
    paymentMethods,
    removeCreditCard,
    setDefaultCreditCard,
    fetchingRemoveCreditCard,
    fetchingSetDefaultCreditCard,
    statusRemoveCreditCard,
    statusSetDefaultCreditCard,
    requestPaymentMethod,
    getRequestPaymentMehods,
    initialPayment,
    statusAttachCreditCard,
    attachCreditCard,
    resetRemoveAndSetDefaultCreditCard,
  } = payment;

  const [isShowCreditCard, setIsShowCreditCard] = useState(false);

  const getData = async () => {
    initialPayment();
    await delay(500);
    if (token) {
      getListPaymentMethods("stripe", token, async () => {
        getRequestPaymentMehods("stripe", token);
        await delay(1000);
        resetRemoveAndSetDefaultCreditCard();
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (
      statusRemoveCreditCard === 200 ||
      statusSetDefaultCreditCard === 200 ||
      statusSetDefaultCreditCard === 204
    ) {
      getData();
    }
  }, [statusRemoveCreditCard, statusSetDefaultCreditCard]);

  useEffect(() => {
    if (statusAttachCreditCard === 200 && attachCreditCard) {
      handelAttachCreditCard();
    }
  }, [statusAttachCreditCard && attachCreditCard]);

  const handelAttachCreditCard = async () => {
    setIsShowCreditCard(false);
    await delay(500);
    getData();
    initialPayment();
  };

  const handleRemoveCreditCard = (item: PaymentMethodType) => {
    if (token) {
      removeCreditCard("stripe", token, item.paymentMethodId);
    }
  };

  const handleSetDefaultCreditCard = (item: PaymentMethodType) => {
    if (token) {
      setDefaultCreditCard("stripe", token, item.paymentMethodId);
    }
  };

  const handleShowCreditCard = () => {
    if (isShowCreditCard) {
      return <AddCreditCard />;
    }
    return (
      <div>
        {paymentMethods && paymentMethods?.length !== 0 ? (
          <div>
            {paymentMethods.map((paymentMethod) => (
              <div className="mb-4">
                <CardStripe
                  item={paymentMethod}
                  onPressRemove={() => {
                    handleRemoveCreditCard(paymentMethod);
                  }}
                  onPressSetDefault={() => {
                    handleSetDefaultCreditCard(paymentMethod);
                  }}
                  isLoadingRemove={fetchingRemoveCreditCard === "pending"}
                  isLoadingSetDefault={
                    fetchingSetDefaultCreditCard === "pending"
                  }
                ></CardStripe>
              </div>
            ))}
          </div>
        ) : (
          <div>
            <div className="ChildItem__mainWrapper">
              <div className="row no-gutters">
                <p className="offset-3 col-6 text-center header--16 color--blue">
                  You haven't any Credit Card.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="mt-10 w-full justify-end mb-4 flex">
        <ButtonLoader
          onClick={() => {
            setIsShowCreditCard(!isShowCreditCard);
          }}
          className="w-64"
        >
          {isShowCreditCard ? "Back" : "Add Credit Card"}
        </ButtonLoader>
      </div>
      <div className="bg-white w-full rounded-lg mt-10 p-10">
        {fetchingPaymnetMethods === "pending" ? (
          <div className="loaderWrapper">
            <div className="preloader preloaderBus" />
          </div>
        ) : (
          requestPaymentMethod?.clientSecret && (
            <Elements
              stripe={stripePromise}
              options={{ clientSecret: requestPaymentMethod?.clientSecret }}
            >
              {handleShowCreditCard()}
            </Elements>
          )
        )}
      </div>
    </div>
  );
});

export default ManageCreditCards;
